<template>
  <v-layout row full-height align-center>
    <v-flex xs12>
      <div class="text-xs-center">
        <v-dialog
          v-model="loading"
          persistent
          hide-overlay
          width="300"
        >
          <v-card
            color="primary"
            dark
          >
            <img class="responsive-img padding" src="./../assets/img/logo.png" alt="fresh start logo">
            <!-- <v-card-media src="./../assets/img/logo.png"></v-card-media> -->
            <v-card-text class="text-xs-center">
              Thank you! You will be redirected shortly, please do not refresh the browser.
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
         <v-dialog v-model="passwordDiag" persistent max-width="500px">
          <v-card>
            <v-card-title>
              <span class="title">Account Created, please also provide a password.</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field label="Password" type="password" v-model="password" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click.native="updatePassword">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import { db, auth } from '@/services/firebase'
export default {
  data () {
    return {
      password: '',
      loading: false,
      passwordDiag: false
    }
  },
  props: ['isTouch'],
  mounted () {
    this.confirmationCheck()
  },
  methods: {
    confirmationCheck: function () {
      this.loading = true
      var self = this
      // Confirm the link is a sign-in with email link.
      if (auth.isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        var email = window.localStorage.getItem('emailForSignIn')
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt('Please provide your email for confirmation')
        }
        // The client SDK will parse the code from the link for you.
        auth.signInWithEmailLink(email, window.location.href)
          .then(function (result) {
            // Check user requires admin role
            var admin = ''
            var phase = ''
            var commencedAt = ''
            var displayName = window.localStorage.getItem('nameForSignIn')
            if (!displayName) {
              displayName = window.prompt('Please provide an display name')
            }
            if (/@leaner-living.com\s*$/.test(email)) {
              admin = true
              commencedAt = null
              phase = null
            } else {
              admin = false
              phase = 1
              commencedAt = null
            }
            db.collection('users').doc(result.user.uid).set({
              name: displayName,
              email: result.user.email,
              admin: admin,
              active: true,
              commenced_at: commencedAt,
              phase: phase
            })
              .then(function (docRef) {
                self.$store.dispatch('setCurrentUser', result.user.uid).then(() => {
                  self.$store.dispatch('fetchUserProfile')
                  self.loading = false
                })
                // Clear local Storage
                window.localStorage.removeItem('emailForSignIn')
                window.localStorage.removeItem('nameForSignIn')
              })
              .catch(function (error) {
                alert('Error: Error adding user information')
                console.error('Error adding user: ', error)
              })
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch(function (error) {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
            alert('Error Signing in')
            console.log(error)
          })
      } else {
        alert('Error: Email conformation not valid')
        console.log('isSignInWithEmailLink: false')
      }
    },
    updatePassword: function () {
      var self = this
      var user = auth.currentUser
      user.updatePassword(self.password).then(function () {
        self.$store.dispatch('fetchUserProfile')
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.password) {
      next()
    } else {
      this.passwordDiag = true
      next(false)
    }
  },
  computed: {
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/signUpConformationView.vue